import React, { useState, useEffect } from 'react'
import './styles.css'
import axios from 'axios'
import { Button } from "reactstrap";
import { Modal, ModalDialog } from "react-bootstrap";
import { sendData, defaultHeaders } from "../../../services/auth";
import { useSelector } from "react-redux";
import { InputLabelAlert } from "../../../common/layout";
import { uriList } from "../../../helpers/config";
import { width } from "../../../helpers";
import moment from 'moment'
import { Collapse, } from 'reactstrap';
import CardCollapse from '../../Cards/CardCollapse'
import UploadDocumentos from '../Documentos/UploadDocumentos'
import { Aguarde, getCookie, getFileSize, zipUrls } from '../../../helpers/general'
import { confirmSwal, swalError, swalWarning } from "../../../helpers/swal";
import { WindowScrollController } from '@fullcalendar/core';
import { copyImageToClipboard } from 'copy-image-clipboard';
import Draggable from "react-draggable";

class DraggableModalDialog extends React.Component {
    render() {
        return (
            <Draggable handle=".modal-header">
                <ModalDialog {...this.props} />
            </Draggable>
        );
    }
}


let statuses = [
    { value: 'ATIVO', name: 'Ativo' },
    { value: 'INATIVO', name: 'Inativo' },
    { value: 'PENDENTE', name: 'Pendente' },
]

let tiposEnvio = [
    { value: 'URL', name: 'Url Arquivo Único' },
    { value: 'ARQUIVO', name: 'Arquivo Único' },
    { value: 'INDIVIDUAL', name: 'Arquivos Individuais' },
]

const InclusaoIntegracoes = (props) => {
    const [data, setData] = useState({})
    const [gravando, setGravando] = useState(false)
    const _login = useSelector((state) => state.login);
    const [validated, setValidated] = useState(false)
    const [obsFullView, setObsFullView] = useState(false)
    const [collapsed, setCollapsed] = useState(false)
    const [collapsedint, setCollapsedInt] = useState(false)
    const [Documentos, setDocumentos] = useState(false)
    const [EditDocument, setEditDocument] = useState(null)
    const [EditIntegracao, setEditIntegracao] = useState(null)
    const [gerandoDossie, setGerandoDossie] = useState(false)
    const [Integracoes, setIntegracoes] = useState(false)
    const [clientes, setClientes] = useState(props.clientes)
    const [pessoas, setPessoas] = useState(props.pessoas)
    const [marcarTodos, setMarcarTodos] = useState(false)
    const [loading, setLoading] = useState(false)
    const [linkSel, setLinkSel] = useState("")

    useEffect(() => {
        // console.log("InclusaoIntegracoes.useEffect:", props.data)
        if (props.data) {
            let _data = {
                ID: props.data.ID,
                EMPRESAID: props.data.EMPRESAID,
                CLIENTEID: props.data.CLIENTEID,
                VALIDADE: moment(props.data.VALIDADE).format('YYYY-MM-DD'),
                PESSOAID: props.data.PESSOAID,
                OBSERVACOES: props.data.OBSERVACOES,
                STATUS: props.data.STATUS,
                TIPO_ENVIO: props.data.TIPO_ENVIO,
                PORTAL: props.data.PORTAL
            }

            // console.log("InclusaoIntegracoes.useEffect(1):", _data)
            setData(_data)
        }
        else
            setData({
                EMPRESAID: props.empresaid || _login.empresaid,
                CLIENTEID: 0,
                VALIDADE: moment(new Date()).format('YYYY-MM-DD'),
                PESSOAID: 0,
                OBSERVACOES: "",
                STATUS: "Ativo",
                TIPO_ENVIO: 'URL',
                PORTAL: ''
            })

        // carregarDados()
    }, [])

    //-- Carrega integrações caso ainda nao tenha carregado
    useEffect(() => {
        carregarDados()
    }, [data.PESSOAID])

    async function carregarDados() {
        // console.log("InclusaoIntegracoes.carregarDados:", data)

        //-- Sai da rotina se não estiver em edição
        if (!props?.data?.ID)
            return

        setLoading(true)
        // console.log("InclusaoIntegracoes.carregarDados(1):", { pessoaId: data.PESSOAID, empresaId: data.EMPRESAID })
        // if (data.PESSOAID != data.EMPRESAID && !Documentos) {
        await sendData({ uri: uriList("documentos"), content: { integracaoid: props?.data?.ID } })
            .then(async (res) => {
                if (res.status && parseInt(res.status) > 200) throw new Error();
                setDocumentos(res.data)
            })
            .catch((e) => {
                console.log(e);
                // alert("Erro ao obter Documentos.\n" + e.message);
            });
        // }
        if (data.PESSOAID == data.EMPRESAID && !Integracoes) {
            await sendData({ uri: uriList("integracoes"), content: { empresaid: props?.data?.EMPRESAID, clienteid: props?.data?.CLIENTEID } })
                .then((res) => {
                    if (res.status && parseInt(res.status) > 200) throw new Error();
                    // console.log("InclusaoIntegracoes.integracoes(ok): ", res.data)
                    setIntegracoes(res.data?.filter(x => x.ID != data?.ID && x.ID != props.data?.ID))
                })
                .catch((e) => {
                    console.log(e);
                    // alert("Erro ao obter Documentos.\n" + e.message);
                });
        }

        if (!clientes || !pessoas) {
            await sendData({ uri: uriList("buscarPessoas"), content: {} })
                .then((res) => {
                    console.log("InclusaoIntegracoes.buscarPessoas(ok)");

                    if (res.status && parseInt(res.status) > 200) throw new Error();
                    else {
                        let _clientes = res?.data?.filter(item => item.CLIENTE == "SIM")
                        let _colaboradores = res?.data?.filter(item => item.COLABORADOR == "SIM" || item.EMPRESA == "SIM")
                        setClientes(_clientes)
                        setPessoas(_colaboradores)
                        // console.log("InclusaoIntegracoes.buscarPessoas(clientes):", _clientes);
                        // console.log("InclusaoIntegracoes.buscarPessoas(colaboradores):", _colaboradores);
                    }
                })
                .catch((e) => {
                    console.log(e);
                    alert("Erro ao buscarClientes.\n" + e.message);
                });
        }

        setLoading(false)
    }

    function validarDados(event) {
        const form = document.getElementById('form-upload-integracoes')
        console.log("InclusaoIntegracoes.validarDados(form): ", form)
        setValidated(false)
        const isValid = form.checkValidity()
        if (!isValid) {
            event.preventDefault()
            event.stopPropagation()
        }

        setValidated(true)
        return isValid
    }

    function gerarDossie() {
        function callback(e) {
            if (e) {
                setGerandoDossie(true)
                sendData({ uri: uriList("gerarDossie"), content: { id: data.ID || data.id, uploadS3: true } })
                    .then((res) => {
                        if (res.status && parseInt(res.status) > 200) throw new Error();
                        console.log("InclusaoIntegracoes.gerarDossie(ok): ", res.data)
                        if (res?.data?.url)
                            setData({ ...data, URL_ARQUIVO: res?.data?.url })
                        // setDocumentos(res.data)
                        setGerandoDossie(false)
                        swalWarning({ title: "Dossiê gerado com sucesso!" })

                        navigator.clipboard.writeText(res?.data?.url)
                        window.open(res?.data?.url)
                    })
                    .catch((e) => {
                        console.log(e);
                        console.log("InclusaoIntegracoes.gerarDossie(error)")
                        setGerandoDossie(false)
                        // alert("Erro ao obter Documentos.\n" + e.message);
                    });
            }
        }

        confirmSwal({ callback, title: "Confirma a geração do Dossiê?" });
    }

    function handlePost(e, isClosed) {
        if (!validarDados(e))
            return
        setGravando(true)
        e.preventDefault()

        console.log("InclusaoIntegracoes.handlePost(1): ", _login.empresaid)

        let formData = new FormData()
        if (data.ID && data.ID != undefined)
            formData.append('id', data.ID)
        formData.append('empresaid', _login.empresaid || props.empresaid);
        formData.append('clienteid', data.CLIENTEID);
        formData.append('validade', moment(data.VALIDADE).format('DD/MM/YYYY'));
        if (data.PESSOAID)
            formData.append('pessoaid', data.PESSOAID);
        formData.append('observacoes', data.OBSERVACOES);
        formData.append('status', data.STATUS);
        formData.append('tipo_envio', data.TIPO_ENVIO);
        formData.append('portal', data.PORTAL);

        console.log("InclusaoIntegracoes.handlePost(Dados): ", data)

        axios({
            url: uriList("integracoesAdd"),
            method: 'POST',
            headers: defaultHeaders(),
            data: formData
        })
            .then(res => {
                setGravando(false)
                console.log("Registro gravado: ", res)
                if (props.data) {
                    if (props.setData)
                        props.setData(data)
                    if (isClosed)
                        handleClose(true)
                }
                setData({})
            })
            .catch(error => {
                setGravando(false)
                console.log("Erro ao gravar registro: ")
                console.log(error)
            })
    }

    function handleClose(_refresh = false) {
        if (props.onCloseEv)
            props.onCloseEv(_refresh)
    }

    function handleChange(e) {
        let target = e.currentTarget;
        let name = target.name;
        // let value = target.value?.toUpperCase();
        // console.log("InclusaoIntegracoes.handleChange: ", target)
        setData({ ...data, [name]: target.value });
        // console.log(`handleChange: ${name} = ${value}`);
    }

    function handleEditDoc(e) {
        console.log("InclusaoIntegracoes.handleEditDoc(1): ", e)
        setEditDocument(e)
    }

    function handleEditIntegra(e) {
        console.log("InclusaoIntegracoes.handleEditDoc(1): ", e)
        setEditIntegracao(e)
    }

    function GetEditDocument() {
        return (
            <UploadDocumentos
                onCloseEv={() => {
                    setEditDocument(null)
                    // setCollapsed(false)
                }}
                pessoaid={EditDocument.PESSOAID}
                empresa={false}
                data={EditDocument}
            />
        )
    }

    function GetEditIntegracao() {
        return (
            <InclusaoIntegracoes
                onCloseEv={() => {
                    setEditIntegracao(null)
                    // setCollapsed(false)
                }}
                // pessoaid={EditIntegracao.PESSOAID}
                empresa={false}
                data={EditIntegracao}
            />
        )
    }

    function handleMarcarTodos() {
        let _sel = !marcarTodos
        setMarcarTodos(_sel)
        let _documentos = Documentos.map(item => {
            return { ...item, selecionado: _sel }
        })
        setDocumentos(_documentos)
        console.log("InclusaoIntegracoes.handleMarcarTodos: ", _documentos)
    }

    function handleMarcar(doc) {
        let _documentos = Documentos.map(item => ({ ...item, selecionado: item.ID == doc.ID ? !item.selecionado : item.selecionado }))
        setDocumentos(_documentos)
        setMarcarTodos(false)
    }

    function getDocuments() {
        return (
            <>
                <table className="table table-striped rounded" title={"Clique para acessar o documento"}>
                    <thead >
                        <th scope="col" style={{ width: "5%" }}><input type="checkbox" id="cb_baixar_todos" checked={marcarTodos} onClick={handleMarcarTodos} style={{ height: "1.5vh", width: "100%" }} /></th>
                        <th scope="col" style={{ width: "65%" }}>Tipo</th>
                        <th scope="col" style={{ width: "15%" }}>Validade</th>
                        <th scope="col" style={{ width: "10%" }}>Tamanho</th>
                        <th scope="col" style={{ width: "5%" }}>*</th>
                    </thead>
                    <tbody>

                        {Documentos && Documentos?.map((doc, index) => {
                            return (
                                <tr style={{ cursor: "pointer" }} onDoubleClick={() => handleEditDoc(doc)} >
                                    <td style={{ width: "5%" }}><input type="checkbox" id="cb_baixar" checked={doc.selecionado} onClick={(e) => handleMarcar(doc)} style={{ height: "1.5vh", width: "100%" }} /></td>
                                    <td style={{ width: "65%" }}>{doc.TIPO_DOCUMENTO}</td>
                                    <td style={{ width: "15%" }}>{moment(doc.VALIDADE).format('DD/MM/YYYY')}</td>
                                    <td style={{ width: "10%" }}>{parseFloat((doc.TAMANHO || 0) / 1024 / 1024).toFixed(2)}</td>
                                    <td style={{ width: "5%" }}><a href={doc.URL_ARQUIVO}><i className="fa fa-download" style={{ color: "black", }} /></a></td>
                                </tr>)
                        })}
                    </tbody>
                </table>
            </>
        )
    }

    function getFooterDocuments() {
        let _selecionados = Documentos && Documentos.filter(item => item.selecionado).length
        return (
            <>
                <div className='d-flex'>
                    <span>Marcados: {_selecionados}</span>
                    <span className='ml-5'>Tamanho Total: {parseFloat(Documentos && Documentos.filter(item => item.selecionado).reduce((a, b) => a + parseFloat(b.TAMANHO || 0) / 1024 / 1024, 0)).toFixed(2)} Mb</span>
                    {(_selecionados > 0) &&
                        <>
                            <span className="ml-3" title={"Clique para fazer download"}>
                                <a href={linkSel}>
                                    <button className="btn-info" onClick={downloadSel} style={{ borderRadius: "4px", border: "0px", width: "30px" }}>
                                        <i className="fa fa-download" style={{ color: "white", }} />
                                    </button>
                                </a>
                            </span>
                        </>
                    }
                </div>
                {linkSel &&
                    <div className='text-center'>
                        <a className="col-11" title={"Clique para fazer download"} href={linkSel} download>{linkSel}</a>
                        <i title={"Clique para copiar"} className="col-1 fa fa-copy" style={{ color: "black", cursor: "pointer" }} onClick={copyLinkSel} />
                        {/* <button className="btn-info " onClick={copyLinkSel} style={{ borderRadius: "4px", border: "0px", width: "30px" }}>
                            
                        </button> */}
                    </div>
                }
            </>
        )
    }

    function getIntegracoes() {
        return (
            <>
                <table className="table table-striped rounded" title={"Clique para acessar a integracao"} style={{ padding: "0 !important" }}>
                    <thead >
                        <th scope="col" style={{ width: "1%" }}></th>
                        <th scope="col" style={{ width: "79%" }}>Pessoa</th>
                        <th scope="col" style={{ width: "20%" }}>Validade</th>
                    </thead>
                    <tbody>
                        {Integracoes?.map((int, index) => {
                            return (
                                <tr style={{ cursor: "pointer" }} onDoubleClick={() => handleEditIntegra(int)} >
                                    <td style={{ width: "1%" }}></td>
                                    <td style={{ width: "79%" }}>{int.PESSOA}</td>
                                    <td style={{ width: "20%" }}>{moment(int.VALIDADE).format('DD/MM/YYYY')}</td>
                                </tr>)
                        })}
                    </tbody>
                </table>
            </>
        )
    }

    function copyLinkSel() {
        navigator.clipboard.writeText(linkSel)
    }

    async function downloadSel(e) {
        console.log("InclusaoIntegracoes.downloadSel(e): ", e)
        e.preventDefault()
        async function callback(e) {
            if (!e)
                return
            let urls = []
            Documentos.map(item => {
                if (item.selecionado)
                    urls.push({ url: item.URL_ARQUIVO, nome: item.TIPO_DOCUMENTO })
            })
            console.log("InclusaoIntegracoes.downloadSel(urls): ", urls)

            if (urls.length > 0) {
                setGerandoDossie(true)
                await sendData({ uri: uriList("getZipUrls"), content: { urls } })
                    .then(async (res) => {
                        if (res.status && parseInt(res.status) > 200) throw new Error();
                        console.log("InclusaoIntegracoes.downloadSel(res): ", res.data)
                        if (res?.data?.url) {
                            window.open(res.data.url)
                            setLinkSel(res.data.url)
                            if (navigator && navigator.clipboard) navigator.clipboard.writeText(res.data.url);
                            // swalWarning({ title: res.data.url })
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        setGerandoDossie(false)
                    });
                setGerandoDossie(false)
            }
        }
        confirmSwal({ callback, title: "Confirma o download?" });
    }

    return (
        <>
            {loading && <Aguarde legenda="Aguarde, carregando dados..." />}
            {gerandoDossie && <Aguarde legenda="Aguarde, gerando arquivo..." />}
            {EditDocument && <GetEditDocument />}
            {EditIntegracao && <GetEditIntegracao />}
            {!EditDocument && !EditIntegracao &&
                <Modal
                    size={width() == "mobile" ? "sm" : "lg"}
                    show={true}
                    onHide={handleClose}
                    centered
                    animation={false}
                    backdrop="static"
                    dialogAs={DraggableModalDialog}
                >
                    <Modal.Header closeButton >
                        <Modal.Title>
                            <span>{`Cadastro de integracoes ${data.ID ? ' - ' + data.ID.toString() : ''} `}</span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="maxWidth750">

                        {gravando ? (
                            <div>Gravando registro...</div>
                        ) : (
                            <form className={`form g-2 border p-2 needs-validation ${validated ? ' was-validated ' : ''}`} noValidade
                                id="form-upload-integracoes">
                                {(collapsed || collapsedint) &&
                                    <>
                                        <div className="row">
                                            <div className={`${width() == "mobile" ? "" : "form-group"} col-md-12`}>
                                                <select className="form-control"
                                                    onChange={(e) => setData({ ...data, CLIENTEID: e.target.value })} required id="CLIENTEIDt" disabled>
                                                    {/* {buscandoClientes ? <option value="" selected={true}>Buscando Clientes...</option> : */}
                                                    <>
                                                        <option value="" selected={!data.CLIENTEID}>Escolha um cliente...</option>
                                                        {clientes?.map((item, key) => {
                                                            if (item.NOME)
                                                                return (
                                                                    <option key={item.PESSOAID} value={item.PESSOAID} selected={data.CLIENTEID == item.PESSOAID}>
                                                                        {item.NOME + " - " + item.CNPJ_CPF}</option>
                                                                )
                                                        })}
                                                    </>

                                                </select>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className={`${width() == "mobile" ? "" : "form-group"} col-md-12`}>
                                                <select className="form-control"
                                                    onChange={e => setData({ ...data, PESSOAID: e.target.value })} disabled>
                                                    <>
                                                        <option value="" selected={!data.PESSOAID}>Escolha uma pessoa...</option>
                                                        {pessoas?.map((item, key) => {
                                                            return (
                                                                <option key={key} value={item.PESSOAID} selected={data.PESSOAID == item.PESSOAID}>{item.NOME + " - " + item.CNPJ_CPF}</option>
                                                            )
                                                        })}
                                                    </>
                                                </select>
                                            </div>
                                        </div>
                                    </>
                                }
                                <Collapse isOpen={!collapsed && !collapsedint}>
                                    {!obsFullView &&
                                        <>

                                            <div className="row">
                                                <div className={`${width() == "mobile" ? "" : "form-group"} col-md-12`}>
                                                    <label className="m-0 font-90">Cliente</label>
                                                    <select className="form-control"
                                                        onChange={(e) => setData({ ...data, CLIENTEID: e.target.value })} required id="CLIENTEID">
                                                        {/* {buscandoClientes ? <option value="" selected={true}>Buscando Clientes...</option> : */}
                                                        <>
                                                            <option value="" selected={!data.CLIENTEID}>Escolha um cliente...</option>
                                                            {clientes?.map((item, key) => {
                                                                if (item.NOME)
                                                                    return (
                                                                        <option key={item.PESSOAID} value={item.PESSOAID} selected={data.CLIENTEID == item.PESSOAID}>
                                                                            {item.NOME + " - " + item.CNPJ_CPF}</option>
                                                                    )
                                                            })}
                                                        </>

                                                    </select>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className={`${width() == "mobile" ? "" : "form-group"} col-md-12`}>
                                                    <label className="m-0 font-90">Pessoa a ser Integrada</label>
                                                    <select className="form-control"
                                                        onChange={e => setData({ ...data, PESSOAID: e.target.value })} >
                                                        <>
                                                            <option value="" selected={!data.PESSOAID}>Escolha uma pessoa...</option>
                                                            {pessoas?.map((item, key) => {
                                                                return (
                                                                    <option key={key} value={item.PESSOAID} selected={data.PESSOAID == item.PESSOAID}>{item.NOME + " - " + item.CNPJ_CPF}</option>
                                                                )
                                                            })}
                                                        </>

                                                    </select>
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className={`${width() == "mobile" ? "" : "form-group"} col-md-3`}>
                                                    <label className="m-0 font-90">Validade</label>
                                                    <input className="form-control" id="VALIDADE"
                                                        type="date" value={data.VALIDADE} onChange={(e) => setData({ ...data, VALIDADE: e.target.value })} required />
                                                </div>
                                                <div className={`${width() == "mobile" ? "" : "form-group"} col-md-4`}>
                                                    <label className="m-0 font-90">Status</label>
                                                    <select className="form-control"
                                                        onChange={e => setData({ ...data, STATUS: e.target.value })} id="STATUS" required>
                                                        <option value="" selected={!data.status}>Defina o Status...</option>
                                                        {statuses ? statuses.map((item, key) => {
                                                            return (
                                                                <option key={key} value={item.value} selected={data.STATUS == item.value}>{item.name}</option>
                                                            )
                                                        }) : "Carregando..."}
                                                    </select>
                                                </div>
                                                <div className={`${width() == "mobile" ? "" : "form-group"} col-md-5`}>
                                                    <label className="m-0 font-90">Tipo de Envio Documentos</label>
                                                    <select className="form-control" id="TIPO_ENVIO"
                                                        onChange={e => setData({ ...data, TIPO_ENVIO: e.target.value })} required>
                                                        <>
                                                            <option value="" selected={!data.TIPO_ENVIO}>Escolha um tipo...</option>
                                                            {tiposEnvio?.map((item, key) => {
                                                                return (
                                                                    <option key={key} value={item.value} selected={data.TIPO_ENVIO == item.value}>{item.name}</option>
                                                                )
                                                            })}
                                                        </>

                                                    </select>
                                                </div>
                                            </div>
                                            {data.PESSOAID == data.EMPRESAID &&
                                                <div className='row'>
                                                    <div className={`${width() == "mobile" ? "" : "form-group"} col-md-12`}>
                                                        <label className="m-0 font-90">Portal</label>
                                                        {data.PORTAL &&
                                                            <a href={data.PORTAL} target="_blank" rel="noreferrer">
                                                                <input className="form-control" id="PORTAL" name="PORTAL" style={{ textTransform: 'lowercase' }}
                                                                    type="url" value={data.PORTAL} onChange={handleChange}
                                                                    placeholder="https://example.com"
                                                                />
                                                            </a>}
                                                        {!data.PORTAL &&
                                                            <input className="form-control" id="PORTAL" name="PORTAL" style={{ textTransform: 'lowercase' }}
                                                                type="url" value={data.PORTAL} onChange={handleChange}
                                                                placeholder="https://example.com"
                                                            />

                                                        }
                                                    </div>
                                                </div>
                                            }
                                            <div className="row">
                                                <div className={`${width() == "mobile" ? "" : "form-group"} col-md-12`}>
                                                    <label for="OBSERVACOES">Observações</label>
                                                    <textarea className='form-control' id="OBSERVACOES" name="OBSERVACOES" type="textarea"
                                                        rows={width() == "mobile" ? 2 : 10} value={data.OBSERVACOES} onChange={handleChange} onDoubleClick={() => setObsFullView(true)}
                                                        title={"Pressione duplo clique para expandir"}
                                                        style={{ textTransform: 'uppercase' }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className={`${width() == "mobile" ? "" : "form-group"} col-md-12`}>
                                                    <InputLabelAlert
                                                        type="text"
                                                        label="Url Dossiê"
                                                        id="urldossie"
                                                        cifrao={false}
                                                        value={props?.data?.URL_ARQUIVO || data?.URL_ARQUIVO}
                                                        lowercase
                                                        disabled
                                                        required
                                                        link
                                                        focus={false}
                                                    />
                                                </div>
                                            </div>
                                        </>}
                                    {obsFullView &&
                                        <div className="row">
                                            <div className={`${width() == "mobile" ? "" : "form-group"} col-md-12`}>
                                                <label for="OBSERVACOES">Observações</label>
                                                <textarea className='form-control' id="OBSERVACOES" name="OBSERVACOES" type="textarea"
                                                    rows={30} value={data.OBSERVACOES} onChange={handleChange} onDoubleClick={() => setObsFullView(false)}
                                                    title={"Pressione duplo clique para voltar"} />
                                            </div>
                                        </div>}
                                </Collapse>
                                {data.PESSOAID == data.EMPRESAID && Integracoes && !collapsed &&
                                    <div className='mt-2' title={!collapsedint ? 'Clique para expandir' : "Clique para fechar"}>
                                        <CardCollapse isOpen={collapsedint} hideHeader title={"Integracoes"} chield={() => getIntegracoes()}
                                            setCollapse={(collapse) => setCollapsedInt(!collapse)} />
                                    </div>
                                }

                                {!collapsedint &&
                                    <div className='mt-2' title={!collapsed ? 'Clique para expandir' : "Clique para fechar"}>
                                        <CardCollapse isOpen={collapsed} hideHeader title={"Documentos"} chield={() => getDocuments()}
                                            footer={() => getFooterDocuments()}
                                            setCollapse={(collapse) => setCollapsed(!collapse)} />
                                    </div>}
                            </form>
                        )}

                    </Modal.Body>
                    <Modal.Footer className="pl-3 pr-3" style={{ display: "flex", justifyContent: "space-between" }}>
                        <div>
                            <Button color="primary" title="Gerar Dossiê" onClick={gerarDossie} disabled={loading}><i className="fa fa-cog" /></Button>
                        </div>

                        <div>
                            <Button color="success" onClick={e => { handlePost(e, false) }} disabled={loading}>
                                Gravar
                            </Button>
                            <Button color="success ml-1" onClick={e => { handlePost(e, true) }} >
                                Gravar e Fechar
                            </Button>
                            <Button color="secondary ml-1" onClick={handleClose}>
                                Fechar
                            </Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            }
        </>
    );
}

export default InclusaoIntegracoes;